import { combineReducers } from 'redux';
export const deleteRedeemUserRewardState = {
    userIdRedeemDeleted: null,
    isLoading: false,
    error: null,
};
const deleteRedeemUserRewardReducer = (state = deleteRedeemUserRewardState, action) => {
    switch (action.type) {
        case 'OLY_ENGINE_DELETE_USER_REDEEM_REWARD':
            return { ...state, isLoading: true, error: null };
        case 'OLY_ENGINE_DELETE_USER_REDEEM_REWARD_SUCCESS':
            return {
                ...state,
                isLoading: false,
                userIdRedeemDeleted: action.payload,
            };
        case 'OLY_ENGINE_DELETE_USER_REDEEM_REWARD_ERROR':
            return { ...state, isLoading: false, error: action.payload.error };
        case 'OLY_ENGINE_DELETE_USER_REDEEM_REWARD_RESET':
            return deleteRedeemUserRewardState;
        default:
            return state;
    }
};
export default combineReducers({
    deleteUserRedeemReward: deleteRedeemUserRewardReducer,
});
